import React, {useRef, useImperativeHandle} from 'react'
import styled from 'styled-components'

const TrackContainer = styled.div`
  background: #eeeeee;
  border-radius: 0.3rem;
  cursor: pointer;
  display: block;
  /* height: 0.3rem; */
  height: 10px;
  position: relative;
  transition: left 0.3s ease-out, width 0.3s ease-out;

  .input-range--disabled & {
    background: #eeeeee;
  }
`

const StyledActiveTrack = styled(TrackContainer)`
  background: #3395fe;
`
const StyledTrack = styled(TrackContainer)`
  left: 0;
  /* margin-top: -0.15rem; */
  margin-top: -5px;
  position: absolute;
  right: 0;
  top: 50%;
`

const Track = (props, ref) => {
  const {draggableTrack, onTrackDrag, onTrackMouseDown, percentages} = props

  const trackRef = useRef(null)

  useImperativeHandle(ref, () => {
    return {
      getClientRect: () => {
        return trackRef.current.getBoundingClientRect()
      }
    }
  })

  const getClientRect = () => {
    return trackRef.current.getBoundingClientRect()
  }

  const trackDragEvent = useRef(null)

  const addDocumentMouseMoveListener = () => {
    removeDocumentMouseMoveListener()
    trackRef.current.ownerDocument.addEventListener(
      'mousemove',
      handleMouseMove
    )
  }

  const addDocumentMouseUpListener = () => {
    removeDocumentMouseUpListener()
    trackRef.current.ownerDocument.addEventListener('mouseup', handleMouseUp)
  }

  const removeDocumentMouseMoveListener = () => {
    trackRef.current.ownerDocument.removeEventListener(
      'mousemove',
      handleMouseMove
    )
  }

  const removeDocumentMouseUpListener = () => {
    trackRef.current.ownerDocument.removeEventListener('mouseup', handleMouseUp)
  }

  const handleMouseMove = evt => {
    if (!draggableTrack) {
      return
    }

    if (trackDragEvent.current !== null) {
      onTrackDrag(evt, trackDragEvent.current)
    }

    trackDragEvent.current = evt
  }

  const handleMouseUp = () => {
    if (!draggableTrack) {
      return
    }

    removeDocumentMouseMoveListener()
    removeDocumentMouseUpListener()
    trackDragEvent.current = null
  }

  const handleTouchStart = evt => {
    evt.preventDefault()

    handleMouseDown(evt)
  }

  const getActiveTrackStyle = () => {
    const width = `${(percentages.max - percentages.min) * 100}%`
    const left = `${percentages.min * 100}%`

    return {left, width}
  }

  const handleMouseDown = evt => {
    const clientX = evt.touches ? evt.touches[0].clientX : evt.clientX
    const trackClientRect = getClientRect()
    const position = {
      x: clientX - trackClientRect.left,
      y: 0
    }

    onTrackMouseDown(evt, position)

    if (draggableTrack) {
      addDocumentMouseMoveListener()
      addDocumentMouseUpListener()
    }
  }

  const activeTrackStyle = getActiveTrackStyle()

  return (
    <StyledTrack
      ref={trackRef}
      onMouseDown={handleMouseDown}
      onTouchStart={handleTouchStart}
      data-testid="input-range-track"
    >
      <StyledActiveTrack style={activeTrackStyle} />
      {props.children}
    </StyledTrack>
  )
}

export default React.forwardRef(Track)
